import PropTypes from 'prop-types';

const WhenOfflineMode = ({enabled, children}) => enabled && children;

WhenOfflineMode.propTypes = {
    enabled: PropTypes.bool.isRequired,
};

WhenOfflineMode.defaultProps = {
    enabled: Boolean(window.DefaultRequestBridge),
};

export default WhenOfflineMode;



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/DownloadButton/WhenOfflineMode.js